import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import * as _ from "lodash";
import { BsModalRef } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { AssetService } from "src/app/_services/asset.service";
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { OnBoardProgressService } from "src/app/_services/on-board-progress.service";
import { OnboardService } from "src/app/_services/onboard.service";
import { UtilServiceService } from "src/app/_services/utilService/util-service.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { ModalServiceService } from "src/app/_services/modal-service.service";

@Component({
  selector: "app-update-child-asset",
  templateUrl: "./update-child-asset.component.html",
  styleUrls: ["./update-child-asset.component.scss"],
  standalone: false,
})
export class UpdateChildAssetComponent extends SubscriptionUtil implements OnInit, OnDestroy{
  translate: any;
  data: any;

  //*** Edit: update some fields */
  updateChildAssetsAddress: boolean = false;
  updateChildAssetsCustodian: boolean = false;
  updateChildAssetsCustomer: boolean = false;
  updateChildAssetsServiceZone: boolean = false;
  updateChildAssetsStatus: boolean = false;

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
    private spinner: NgxSpinnerService,
    private errorUtil: ErrorUtil,
    private progressService: OnBoardProgressService,
    private onboardService: OnboardService,
    private assetService: AssetService,
    private util: UtilServiceService,
    private router: Router,
    private modalServc: ModalServiceService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
  }

  getLanguageData() {
    // this.spinner.show()
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  public onSubmit() {
    let formData;
    formData = _.cloneDeep(this.data);
    if (this.updateChildAssetsStatus) {
      //Call the vaidate api. If the 'valid' flag is false, then open the popup.
      this.push(this.assetService.getValidateComponent(formData.assetsStatus.id, formData.id).subscribe({
        next: (res: any) => {
          if (res.status == 200){
            let isValid: boolean = res.body.valid;
            if (!isValid){
              //open the modal
              let data: any = formData;
              data['addressChecked'] = this.updateChildAssetsAddress;
              data["custodianChecked"] = this.updateChildAssetsCustodian;
              data["customerChecked"] = this.updateChildAssetsCustomer;
              data["servicezoneChecked"] = this.updateChildAssetsServiceZone;
              data["assetstatusChecked"] = this.updateChildAssetsStatus;
              this.modalRef.hide();
              const confirmModal = this.modalServc.openModal("updateAssetStatusComponent", data);
              confirmModal?.onHide?.subscribe((reason: any) =>{
                if (reason == 'update-confirmed'){
                 // this.modalRef.hide();
                  this.router.navigate(["dashboard/assets/view/" + formData.id], {
                    queryParams: { id: res.body.id, serialNo: null },
                  });
                }
              })
            }
            else{
              //proceed as usual
              this.push(this.assetService.editAsset(
                formData,
                this.updateChildAssetsAddress,
                this.updateChildAssetsCustodian,
                this.updateChildAssetsCustomer,
                this.updateChildAssetsServiceZone,
                this.updateChildAssetsStatus,
              )
              .subscribe(
                (res: any) => {
                  if (res.status === 200 || res.status === 201) {
                    this.spinner.hide();
                    this.errorUtil.setErrorMessage(
                      200,
                      this.translate?.general.messages.updatedSuccessfully,
                      null,
                      "success",
                      3000,
                    );

                    this.util.resetTabView();
                    this.modalRef.hide();
                    this.router.navigate(
                      ["dashboard/assets/view/" + res.body.id],
                      {
                        queryParams: { id: res.body.id, serialNo: null },
                      },
                    );
                  } else {
                    var errorTitle = res.error.title;
                    if (res.error.type == "dynamic-lang-error") {
                      var data =
                        res.error.instance +
                        ".validationBE." +
                        res.error.detail;
                      var message =
                        this.languageTranslateService.getNestedValue(
                          this.translate,
                          data,
                        );
                      errorTitle = message;
                    }

                    this.errorUtil.setErrorMessage(
                      res.status,
                      null,
                      errorTitle,
                      "error",
                      2000,
                    );
                  }
                  // Open the modal using the ModalServiceService
                  // const modalRef = this.modalService.openModal("updateChildAsset", {data: this.asset});
                },
                (err) => {
                  console.log(err);
                  const title = this.errorUtil.processErrorTitle(
                    err.error,
                    this.translate,
                  );
                  this.errorUtil.setErrorMessage(
                    400,
                    null,
                    title,
                    "error",
                    3000,
                  );
                },
              ));
            }
          }
        },
        error: (err: any) =>{
          console.log(err, 'error printing from validate api')
          const title = this.errorUtil.processErrorTitle(
            err.error,
            this.translate,
          );
          this.errorUtil.setErrorMessage(400, null, title, "error", 3000);
        }
      }));
     
    } else {
      this.push(
        this.assetService
          .editAsset(
            formData,
            this.updateChildAssetsAddress,
            this.updateChildAssetsCustodian,
            this.updateChildAssetsCustomer,
            this.updateChildAssetsServiceZone,
            this.updateChildAssetsStatus,
          )
          .subscribe(
            (res: any) => {
              if (res.status === 200 || res.status === 201) {
                this.spinner.hide();
                this.errorUtil.setErrorMessage(
                  200,
                  this.translate?.general.messages.updatedSuccessfully,
                  null,
                  "success",
                  3000,
                );

                this.util.resetTabView();
                this.modalRef.hide();
                this.router.navigate(["dashboard/assets/view/" + res.body.id], {
                  queryParams: { id: res.body.id, serialNo: null },
                });
              } else {
                var errorTitle = res.error.title;
                if (res.error.type == "dynamic-lang-error") {
                  var data =
                    res.error.instance + ".validationBE." + res.error.detail;
                  var message = this.languageTranslateService.getNestedValue(
                    this.translate,
                    data,
                  );
                  errorTitle = message;
                }

                this.errorUtil.setErrorMessage(
                  res.status,
                  null,
                  errorTitle,
                  "error",
                  2000,
                );
              }
              // Open the modal using the ModalServiceService
              // const modalRef = this.modalService.openModal("updateChildAsset", {data: this.asset});
            },
            (err) => {
              console.log(err);
              const title = this.errorUtil.processErrorTitle(
                err.error,
                this.translate,
              );
              this.errorUtil.setErrorMessage(400, null, title, "error", 3000);
            },
          ),
      );
    }
  }
}
